/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { NamedExoticComponent, RefAttributes } from 'react';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next/withAnalyticsEvents';
import { lazyAfterPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type KeyboardShortcutsType from './view/index.tsx';
import type { Props } from './view/view.tsx';

export const KeyboardShortcuts: LazyComponent<
	NamedExoticComponent<
		Omit<
			Omit<
				// oxlint-disable-next-line @typescript-eslint/no-explicit-any
				Omit<Props, keyof WithAnalyticsEventsProps> & RefAttributes<any>,
				| 'showSearch'
				| 'showIssueCreate'
				| 'navigateToIssueSearch'
				| 'navigateToMostRecentProject'
				| 'ApplicationPermissionsSubscriber'
				| 'KeyboardShortcutsDialog'
				| 'ProjectCreateDrawerConsumer'
				| 'Shortcuts'
				| 'NavUIControllerSubscriber' // oxlint-disable-next-line @typescript-eslint/no-explicit-any
				| keyof RefAttributes<any>
				| 'shouldUseHelpShortcut'
				| 'toggleHelpPanel'
			> &
				// oxlint-disable-next-line @typescript-eslint/no-explicit-any
				Partial<Partial<Omit<Props, keyof WithAnalyticsEventsProps> & RefAttributes<any>>>,
			| 'navigateToIssueSearch'
			| 'navigateToMostRecentProject'
			| 'ApplicationPermissionsSubscriber'
			| 'KeyboardShortcutsDialog'
			| 'ProjectCreateDrawerConsumer'
			| 'Shortcuts'
			| 'NavUIControllerSubscriber'
		>
	>
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint<typeof KeyboardShortcutsType>(
		() => import(/* webpackChunkName: "async-keyboard-shortcuts-mapping" */ './view/index.tsx'),
		{ ssr: false },
	);
